import React from 'react'
import { useTranslation } from '@mc/i18n'
import { useExperiment } from '../../hooks/useExperiment'
import { PLAN_Z_FREE_GIFT_I18N_NAMESPACE } from '../../i18n'

const TERMS_LINK =
  'https://www.masterclass.com/terms/2026-fathers-day-free-gift'

export const ExplainerModalTermsLink = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { t } = useTranslation(PLAN_Z_FREE_GIFT_I18N_NAMESPACE)

  const { isVariant: isPlanZFreeGift } = useExperiment({ isGift: false })

  if (!isPlanZFreeGift) return children

  return (
    <a
      className='mc-text--link'
      href={TERMS_LINK}
      target='_blank'
      rel='noopener noreferrer'
    >
      {t('freeGift.explainer.terms')}
    </a>
  )
}
